'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex: 0 0 ', 'px;\n  height: ', 'px;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex: 0 0 ', 'px;\n  height: ', 'px;\n  justify-content: center;\n']);

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _colors = require('HubStyleTokens/colors');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Constants = require('ui-addon-avatars/Constants');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _isAvailable = require('conversations-schema/operators/agent-state/isAvailable');

var _AvatarSize = require('conversations-schema/constants/AvatarSize');

var _ChatHead = require('./ChatHead');

var _ChatHead2 = _interopRequireDefault(_ChatHead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BORDER_WIDTH = 2;

var chatHeadCenter = function chatHeadCenter() {
  var borderColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors.OLAF;
  return {
    border: BORDER_WIDTH + 'px solid ' + borderColor,
    background: '' + borderColor,
    borderRadius: '50%',
    zIndex: 0
  };
};

var getMarginLeft = function getMarginLeft(size) {
  switch (size) {
    case _AvatarSize.SMALL:
      return -10;
    case _AvatarSize.EXTRA_SMALL:
      return -15;
    default:
      return -10;
  }
};

var chatHeadRight = function chatHeadRight(borderColor, zIndex, size) {
  return _extends({}, chatHeadCenter(borderColor), {
    zIndex: zIndex,
    marginLeft: getMarginLeft(size)
  });
};

var ChatHeadGroupWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'ChatHeadGroup__ChatHeadGroupWrapper'
})(_templateObject, function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return _Constants.AVATAR_SIZES[size] + BORDER_WIDTH * 2;
});

function getChatHeadStyle(index, borderColor, size) {
  if (index >= 1) {
    return chatHeadRight(borderColor, index, size);
  }

  return chatHeadCenter(borderColor);
}

function ChatHeadGroup(_ref3) {
  var showStatusIndicator = _ref3.showStatusIndicator,
      responders = _ref3.responders,
      borderColor = _ref3.borderColor,
      size = _ref3.size;

  var chatHeadElements = responders.map(function (responder, index) {
    var avatar = (0, _responderGetters.getAvatar)(responder);
    var online = (0, _isAvailable.isAvailable)(responder);
    var isBot = (0, _responderGetters.getIsBot)(responder);
    var userId = (0, _responderGetters.getUserId)(responder);
    var style = getChatHeadStyle(index, borderColor, size);
    var className = (0, _classNames2.default)('chat-head', {
      'chat-group-head-right': index >= 1
    });
    return _react2.default.createElement(_ChatHead2.default, {
      avatar: avatar,
      className: className,
      isBot: isBot,
      isVisitorWidget: true,
      key: 'chat-head.' + userId,
      online: online,
      responder: responder,
      showStatus: showStatusIndicator,
      size: size,
      style: style
    });
  });

  return _react2.default.createElement(
    ChatHeadGroupWrapper,
    { size: size },
    chatHeadElements
  );
}

ChatHeadGroup.propTypes = {
  borderColor: _react.PropTypes.string.isRequired,
  responders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  showStatusIndicator: _react.PropTypes.bool.isRequired,
  size: _react.PropTypes.string.isRequired
};

ChatHeadGroup.defaultProps = { showStatusIndicator: false, size: _AvatarSize.SMALL };

exports.default = ChatHeadGroup;
module.exports = exports['default'];